var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-localization"},[_c('div',{staticClass:"v-localization__toolbar"},[_c('lfs-toolbar')],1),_c('div',{staticClass:"v-localization__table"},[_c('c-localization-table')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }